import type { FaireProductEntity } from "../../entity_types/product";

export const p_pazhz6k6my: FaireProductEntity = {
  token: "p_pazhz6k6my",
  type: "product",
  name: "I smell snow Gilmore Girls Sweatshirt",
  brandToken: "b_uvyajnxvs2",
  brandName: "Letters and Lucy",
  imageUrl:
    "https://cdn.faire.com/fastly/e73415f71d3615218c12046eef1a5ccf387e486626f69abf5a907db2a65f42bf.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6ba04d91535ea760421336afda5f82c99ccec043ed4b92e0f4e9ffce2bf8e73b.png",
    "https://cdn.faire.com/fastly/56ba91e114acb99643303c3ec0b121fca178ee3680aea03b98733027890b537a.png",
    "https://cdn.faire.com/fastly/74958d5487c13a5f47a8ec647006dffe758f83c1548a3bf9c55f9c55bc9ce039.png",
  ],
  priceDollars: 33.07,
  description:
    '50% COTTON 50% POLY\n\nDisclaimer: Each piece is unique! Because of the tie-dye wash, shades and patterns may vary slightly.\n\n**If available, Click "customize this item" to specify font color**\n\nUnisex Sizing - Size down for fitted, true to size for normal, relaxed fit, size up for oversized.  View sizing chart here.\n\nWant this design printed on another color of sweatshirt? Not a problem! Let\'s chat & choose a custom color :)\n\nMade in United States of America',
  tags: [],
  msrpDollars: 66.14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-21T20:34:44.046Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
